import { IcecastReadableStream } from 'icecast-metadata-js';
import { TIMEOUT } from '../../../constants';
import type { FetchMetadataProps } from '../createMetadataFetcher';
import { createMetadataFetcher } from '../createMetadataFetcher';

// https://cast.readme.io/docs/icy#metadata
interface IcyMetadata {
  metadata: {
    StreamTitle?: string;
    StreamUrl?: string;
  };
}

export const fetchIcy = async ({
  abortController = new AbortController(),
  ...forwardingProps
}: FetchMetadataProps) => {
  return createMetadataFetcher({
    ...forwardingProps,
    abortController,
    parser: (response) => {
      return new Promise<string | undefined>((resolve) => {
        const timeout = setTimeout(() => {
          abortController.abort();
          resolve(undefined);
        }, TIMEOUT);

        new IcecastReadableStream(response, {
          metadataType: 'icy',
          onMetadata: ({ metadata: { StreamTitle: title } }: IcyMetadata) => {
            clearTimeout(timeout);
            abortController.abort();
            resolve(title);
          },
          onMetadataError: () => {
            clearTimeout(timeout);
            abortController.abort();
            resolve(undefined);
          }
        }).startReading();
      });
    },
    headers: new Headers({ 'Icy-MetaData': '1' })
  });
};
